import { useI18n } from 'vue-i18n';
import en from '../i18n/locale/en.json';
import ptBR from '../i18n/locale/pt_BR.json';

const MESSAGES = { en, pt_BR: ptBR, pt: ptBR };

// The dashboard's locale codes (pt_BR) as Intl tags (pt-BR), for dates and numbers
export const intlLocale = locale => locale.replace('_', '-');
const merged = new WeakSet();

// The dashboard's global vue-i18n instance with the fork's LOCO.* strings merged in. Locales without a fork
// translation get English, so a key never shows up raw.
export function useLocoI18n() {
  const i18n = useI18n();
  if (!merged.has(i18n)) {
    const locales = new Set([
      ...i18n.availableLocales,
      i18n.locale.value,
      'en',
    ]);
    locales.forEach(locale => {
      i18n.mergeLocaleMessage(locale, MESSAGES[locale] || en);
    });
    merged.add(i18n);
  }
  return i18n;
}
